import { parseParticlePreset } from './particle-validation.js';
function sortJson(value) {
    if (Array.isArray(value))
        return value.map(sortJson);
    if (typeof value !== 'object' || value === null)
        return value;
    const sorted = {};
    for (const key of Object.keys(value).sort()) {
        const item = value[key];
        if (item !== undefined)
            sorted[key] = sortJson(item);
    }
    return sorted;
}
/** Serialize a validated particle preset with deterministic key ordering. @public */
export function serializeParticlePreset(value, options = {}) {
    const preset = parseParticlePreset(value);
    const space = Math.max(0, Math.min(10, options.space ?? 2));
    return `${JSON.stringify(sortJson(preset), null, space)}\n`;
}
//# sourceMappingURL=particle-serialization.js.map